//#region src/group_ordering_mode.ts
var GroupOrderingMode = /* @__PURE__ */ function(GroupOrderingMode) {
	GroupOrderingMode["Off"] = "off";
	GroupOrderingMode["AskGroupOrderOptional"] = "ask-group-order-optional-recipients";
	GroupOrderingMode["AskGroupOrderRequired"] = "ask-group-order-required-recipients";
	return GroupOrderingMode;
}(GroupOrderingMode || {});
//#endregion
export { GroupOrderingMode };

//# sourceMappingURL=group_ordering_mode.js.map